import _Promise from 'babel-runtime/core-js/promise';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import { random } from './string';

var Resolve = function Resolve() {
  var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;

  _classCallCheck(this, Resolve);

  _initialiseProps.call(this);

  this.delay = delay;
  /* { id: { timeout, promise } } */
  this.pending = {};
}

/*
 ** !!! BE CAREFUL : make sure to wrap this call inside try/catch : prevent loading bundle.js on unhandled promise rejection !!!
 ** call this method if you want to execute your "next" promise function only once after a delay
 ** next should be a function returning a promise (ie: api.todolist.get),
 ** this method will resolve | reject your promise
 */


/*
 ** call this method if you want to execute your "next" callback only once after a delay
 */
;

var _initialiseProps = function _initialiseProps() {
  var _this = this;

  Object.defineProperty(this, 'resolveNext', {
    enumerable: true,
    writable: true,
    value: function value(id) {
      /* in case of manual cancel */
      if (!_this.pending[id]) {
        return;
      }
      var _pending$id = _this.pending[id],
          resolve = _pending$id.resolve,
          reject = _pending$id.reject;

      var result = _this.pending[id].next();

      /* if next returns a promise */
      if (resolve && reject && result && result.then) {
        result.then(resolve).catch(reject);
      }
      delete _this.pending[id];
    }
  });
  Object.defineProperty(this, 'awaitOnce', {
    enumerable: true,
    writable: true,
    value: function value(id, next) {
      var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.delay;

      if (typeof next !== 'function') {
        return _Promise.reject('2nd parameter should be a function');
      }
      return new _Promise(function (resolve, reject) {
        id = id || random();
        if (_this.pending[id]) {
          clearTimeout(_this.pending[id].timeout);
          /* IMPORTANT : WRAP your call inside try/catch */
          _this.pending[id].reject({ id: id, cancel: true });
        }

        _this.pending[id] = {
          resolve: resolve,
          reject: reject,
          next: next,
          timeout: setTimeout(function () {
            return _this.resolveNext(id);
          }, delay)
        };
      });
    }
  });
  Object.defineProperty(this, 'once', {
    enumerable: true,
    writable: true,
    value: function value(id, next) {
      var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.delay;

      if (typeof next !== 'function') {
        return;
      }
      id = id || random();
      if (_this.pending[id]) {
        clearTimeout(_this.pending[id].timeout);
      }

      _this.pending[id] = {
        next: next,
        timeout: setTimeout(function () {
          return _this.resolveNext(id);
        }, delay)
      };
    }
  });
  Object.defineProperty(this, 'cancel', {
    enumerable: true,
    writable: true,
    value: function value(id) {
      if (_this.pending[id] && _this.pending[id].timeout) {
        clearTimeout(_this.pending[id].timeout);
      }
      if (_this.pending[id] && _this.pending[id].reject) {
        _this.pending[id].reject({ id: id, cancel: true });
      }
      delete _this.pending[id];
    }
  });
};

export default new Resolve();
//# sourceMappingURL=resolve.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/utils/resolve.js
// module id = 410
// module chunks = 0